import React from 'react';
import DsButton from '../../common/DsButton';
import { CardListSkeleton } from '../../common/ContentSkeletons';
import EventMarketingSummaryCard from './EventMarketingSummaryCard';

type EventDetailsOverviewSidebarPanelsProps = {
  view: any;
};

export default function EventDetailsOverviewSidebarPanels({ view }: EventDetailsOverviewSidebarPanelsProps) {
  const {
    bannerActionLoading,
    bannerUrl,
    canEditEventInfo,
    canViewTicketSales,
    eventFinanceSummary,
    eventFinanceSummaryLoading,
    eventFinanceVisual,
    eventId,
    eventReadOnlyTitle,
    formatCurrency,
    handleBannerDelete,
    navigate,
    promptBannerUpload,
    renderInheritanceNotice,
    usesParentAssets,
  } = view;

  return (
    <>
      <section
        className="event-panel banner-panel event-detail-sidebar-panel"
        id="event-banner-section"
      >
        <div className="panel-heading">
          <div>
            <h3>イベントバナー</h3>
          </div>
        </div>
        <div className="banner-frame">
          {bannerUrl ? (
            <img src={bannerUrl} alt="イベントバナー" className="banner-image" />
          ) : usesParentAssets ? (
            <p className="banner-empty">バナーが登録されていません</p>
          ) : (
            <div className="banner-empty action-button">
              <DsButton
                variant="secondary"
                size="sm"
                icon
                onClick={promptBannerUpload}
                disabled={!canEditEventInfo || bannerActionLoading}
                title={!canEditEventInfo ? eventReadOnlyTitle : undefined}
                aria-label="バナーを追加"
              >
                <i className="fa-solid fa-image" aria-hidden="true"></i>
              </DsButton>
            </div>
          )}
        </div>
        {usesParentAssets ? (
          renderInheritanceNotice('バナー')
        ) : bannerUrl ? (
          <div className="banner-manage-controls">
            <DsButton
              variant="secondary"
              size="sm"
              icon
              onClick={promptBannerUpload}
              disabled={!canEditEventInfo || bannerActionLoading}
              title={!canEditEventInfo ? eventReadOnlyTitle : undefined}
              aria-label="バナーを差し替え"
            >
              <i className="fa-solid fa-image" aria-hidden="true"></i>
            </DsButton>
            <DsButton
              variant="danger"
              size="sm"
              icon
              onClick={handleBannerDelete}
              disabled={!canEditEventInfo || bannerActionLoading}
              title={!canEditEventInfo ? eventReadOnlyTitle : undefined}
              aria-label="バナーを削除"
            >
              <i className="fa-solid fa-trash" aria-hidden="true"></i>
            </DsButton>
          </div>
        ) : null}
      </section>

      <div className="event-detail-sidebar-marketing" data-testid="event-detail-sidebar-marketing">
        <EventMarketingSummaryCard eventId={eventId} navigate={navigate} />
      </div>

      {canViewTicketSales ? (
        <section
          className="event-panel event-finance-panel event-detail-sidebar-panel"
          id="event-finance-section"
        >
          <div className="panel-heading">
            <div>
              <h3>イベント経理</h3>
            </div>
          </div>
          <div className="event-finance-summary">
            {eventFinanceSummaryLoading ? (
              <CardListSkeleton rows={3} />
            ) : eventFinanceSummary ? (
              <>
                <div className="event-finance-cards">
                  <div className="ef-card">
                    <div className="ef-card-title">収益合計</div>
                    <div className="ef-card-value">¥{formatCurrency(eventFinanceVisual.revenue)}</div>
                  </div>
                  <div className="ef-card">
                    <div className="ef-card-title">費用合計</div>
                    <div className="ef-card-value">¥{formatCurrency(eventFinanceVisual.expense)}</div>
                  </div>
                  <div className={`ef-card ${eventFinanceVisual.profit >= 0 ? 'is-profit' : 'is-loss'}`}>
                    <div className="ef-card-title">収支</div>
                    <div className="ef-card-value">¥{formatCurrency(eventFinanceVisual.profit)}</div>
                    <div className="ef-card-meta">
                      {eventFinanceVisual.profit >= 0 ? '黒字' : '赤字'}{' '}
                      {Math.abs(eventFinanceVisual.margin).toFixed(1)}%
                    </div>
                  </div>
                </div>
                <div className="event-finance-visual">
                  <div className="ef-compare-row">
                    <span className="ef-compare-label">収益</span>
                    <div className="ef-compare-track">
                      <div
                        className="ef-compare-bar is-revenue"
                        style={{ width: `${eventFinanceVisual.revenueWidth}%` }}
                      />
                    </div>
                    <span className="ef-compare-value">¥{formatCurrency(eventFinanceVisual.revenue)}</span>
                  </div>
                  <div className="ef-compare-row">
                    <span className="ef-compare-label">費用</span>
                    <div className="ef-compare-track">
                      <div
                        className="ef-compare-bar is-expense"
                        style={{ width: `${eventFinanceVisual.expenseWidth}%` }}
                      />
                    </div>
                    <span className="ef-compare-value">¥{formatCurrency(eventFinanceVisual.expense)}</span>
                  </div>
                </div>
              </>
            ) : (
              <p className="muted">イベント経理データがまだ登録されていません。</p>
            )}
          </div>
          <div className="panel-footer">
            <DsButton
              variant="secondary"
              onClick={() => navigate(`/admin/workspaces/event-operations/events/${eventId}/pl`)}
            >
              イベントPL
            </DsButton>
          </div>
        </section>
      ) : null}
    </>
  );
}
